import React from 'react'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'
import 'tippy.js/themes/light.css'

const FunctionsOption = () => {
  const functions = [
    {
      title: 'クラウド編集機能',
      tooltip: <>クラウド上で複数人の編集が可能</>,
      background: 'light',
      option: false
    },
    {
      title: 'AI検索',
      tooltip: (
        <>
          キーワード検索だけでなく
          <br />
          様々な検索が可能
        </>
      ),
      background: 'light',
      option: false
    },
    {
      title: 'AIレビューアシスト',
      tooltip: (
        <>
          自社雛形や過去文書との
          <br />
          比較をAIがアシスト
        </>
      ),
      background: 'white',
      option: false
    },
    {
      title: 'ナレッジ管理',
      tooltip: (
        <>
          クラウド上でのデータ管理に
          <br />
          より、属人化を防止
        </>
      ),
      background: 'white',
      option: false
    },
    {
      title: 'AI-OCR',
      tooltip: <>手書き文書も撮影写真を格納すれば、AIが解析してデータ化</>,
      background: 'light',
      option: false
    },
    {
      title: 'キーワード検索',
      tooltip: (
        <>
          キーワードから
          <br />
          文書や条項を検索可能
        </>
      ),
      background: 'light',
      option: false
    },
    {
      title: '類似条項検索',
      tooltip: (
        <>
          似ている条項を、AIが
          <br />
          類似度順に自動リストアップ
        </>
      ),
      background: 'white',
      option: false
    },
    {
      title: 'タグ付け機能',
      tooltip: (
        <>
          文書に任意のタグを
          <br />
          付与して、文書管理を容易に
        </>
      ),
      background: 'white',
      option: false
    },
    {
      title: '文書比較',
      tooltip: '任意の文書と条項単位で比較して編集',
      background: 'light',
      option: false
    },
    {
      title: 'リスト設定',
      tooltip: (
        <>
          数クリックで条番号などの
          <br />
          リストを柔軟に設定可能
        </>
      ),
      background: 'light',
      option: false
    },
    {
      title: 'Wordアドイン',
      tooltip: 'WordとLAWGUEの社内併用も可能',
      background: 'white',
      option: false
    },
    {
      title: 'ステータス管理',
      tooltip: (
        <>
          「レビュー中」などの
          <br />
          ステータスを付与
        </>
      ),
      background: 'white',
      option: false
    },
    {
      title: 'コメント機能',
      tooltip: (
        <>
          過去のコメントも
          <br />
          すべてLAWGUE上に記録
        </>
      ),
      background: 'light',
      option: false
    },
    {
      title: '自社テンプレート',
      tooltip: (
        <>
          自社雛形を
          <br />
          解説付きで作成可能
        </>
      ),
      background: 'light',
      option: false
    },
    {
      title: '閲覧権限設定',
      tooltip: (
        <>
          アカウント毎に閲覧可能な
          <br />
          文書を設定可能
        </>
      ),
      background: 'white',
      option: false
    },
    {
      title: '法令出版社の雛形搭載',
      tooltip: (
        <>
          新日本法規出版、
          <br />
          第一法規の雛形を搭載可能
        </>
      ),
      background: 'white',
      option: true
    },
    {
      title: '電子契約連携',
      tooltip: (
        <>
          シームレスに電子契約が可能
          <br />
          （連携先：クラウドサイン）
        </>
      ),
      background: 'light',
      option: true
    },
    {
      title: '文書管理連携',
      tooltip: (
        <>
          データ連携可能（連携先：
          <br />
          鈴与の文書管理システム）
        </>
      ),
      background: 'light',
      option: true
    },
    {
      title: 'AI翻訳',
      tooltip: (
        <>
          日英文書の翻訳が可能
          <br />
          （連携サービス：T-4OO）
        </>
      ),
      background: 'white',
      option: true
    },
    {
      title: 'AIメンター機能',
      tooltip: (
        <>
          様々な質問に
          <br />
          自社ナレッジからAIが回答
        </>
      ),
      background: 'white',
      option: true
    }
  ]

  return (
    <section>
      <div className="mx-auto px-6 xl:px-0 pt-16 pb-16 text-center lg:pt-32 lg:pb-32 lg:max-w-[1200px]">
        {/* タイトル */}
        <h2 className="text-lg font-bold text-textblack lg:text-4xl font-feature-setting">
          その他機能
        </h2>

        {/* グリッド部分 */}
        <div className="grid grid-cols-1 md:grid-cols-2 text-lg border border-solid border-gray rounded-md w-full overflow-hidden mt-16">
          {functions.map((func, index) => (
            <div
              key={index}
              className={`
              relative flex items-center min-h-16 p-4
              ${func.background === 'light' ? 'bg-lawguebase' : 'bg-white'}
              ${
                index % 2 === 0 &&
                index !== functions.length - 1 &&
                'md:border-r border border-solid border-gray'
              }
              ${
                index <
                  functions.length - (functions.length % 2 === 0 ? 2 : 1) &&
                'border border-solid border-gray'
              }
            `}
            >
              <div className="flex items-center gap-3 flex-1">
                <div className="text-lg font-bold">{func.title}</div>

                <Tippy
                  content={<div className="text-sm">{func.tooltip}</div>}
                  placement="top" // 常に上向きに表示
                  arrow={true}
                  theme="custom"
                  maxWidth={200}
                  appendTo={() => document.body}
                  offset={[0, 10]} // [x, y] オフセット
                  popperOptions={{
                    modifiers: [
                      {
                        name: 'preventOverflow',
                        options: {
                          altAxis: true,
                          padding: 5
                        }
                      }
                    ]
                  }}
                >
                  <div className="w-6 h-6 flex items-center justify-center cursor-pointer">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <rect
                        width="24"
                        height="24"
                        fill="none"
                        strokeWidth="0"
                      />
                      <path
                        d="m12,21c-4.97,0-9-4.04-9-9S7.03,3,12,3s9,4.04,9,9-4.04,9-9,9h0Zm0-16.37c-4.06,0-7.37,3.3-7.37,7.37s3.3,7.36,7.36,7.36,7.36-3.3,7.36-7.36-3.3-7.37-7.36-7.37Z"
                        fill="#c8bda8"
                        strokeWidth="0"
                      />
                      <path
                        d="m12,16.09c-.45,0-.82-.37-.82-.82v-3.27c0-.45.37-.82.82-.82s.82.37.82.82v3.27c0,.45-.37.82-.82.82Z"
                        fill="#c8bda8"
                        strokeWidth="0"
                      />
                      <path
                        d="m12.01,9.55c-.45,0-.82-.37-.82-.82s.36-.82.81-.82h0c.45,0,.82.37.82.82s-.37.82-.82.82h0Z"
                        fill="#c8bda8"
                        strokeWidth="0"
                      />
                    </svg>
                  </div>
                </Tippy>

                {func.option && (
                  <div className="bg-secondary text-white text-xs font-bold py-1 px-2 rounded">
                    オプション
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default FunctionsOption
